import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

import { TestResultsPage as TestResultsPluginPage } from './components/TestResultsPage';

export const testResultsPlugin = createPlugin({
  id: 'test-results',
  routes: {
    root: rootRouteRef,
  },
});

export const TestResultsPage = testResultsPlugin.provide(
  createComponentExtension({
    component: {
      sync: TestResultsPluginPage,
    },
  }),
);
